<template><div><h1>VUX V2.7.1 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix less variables do not work in plugin usage #2152</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[enhance] support object-link #2068</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] fix prevent-body-scroll.css not found (less-loader issue) #2118</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] fix valid is false when value is zero #2134</li>
<li>[fix] fix event:on-blur not fires #2146</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.1-132.vue?cebd1ce2